






import Vue from 'vue';

import OrganizationPacketSwitch from '@/views/authenticated/OrganizationPacketSwitch.vue';
import OrganizationLoadGuard from '@/components/OrganizationLoadGuard.vue';

export default Vue.extend({
  components: {
    OrganizationPacketSwitch,
    OrganizationLoadGuard
  },

  props: {
    organizationId: Number,
    packetId: Number
  }
});
